import { SortState } from '@matillion/component-library'
import { GETBranchesResponseParams } from 'api/types'

import { BranchTypes } from '.'

export const branchesSort =
  (sortState: Partial<SortState<GETBranchesResponseParams>>) =>
  (a: GETBranchesResponseParams, b: GETBranchesResponseParams): number => {
    const sortStateType = Object.keys(sortState)[0] as BranchTypes
    if (sortState?.[sortStateType] === 'ASC') {
      return a[sortStateType].localeCompare(b[sortStateType])
    } else {
      return b[sortStateType].localeCompare(a[sortStateType])
    }
  }
